import { styled } from '@mui/material/styles';
import MuiDrawer from '@mui/material/Drawer';
import MuiDivider from '@mui/material/Divider';
import MuiListItemButton from '@mui/material/ListItemButton';
import MuiListItemIcon from '@mui/material/ListItemIcon';
import MuiListItemText from '@mui/material/ListItemText';
import { TOOLBOX_MINIFIED_MENU_WIDTH, TOOLBOX_MAXIMIZED_MENU_WIDTH } from "constants/flowDesigner";
import { THEME_COLORS } from 'constants/theme';

const openedMixin = (theme) => ({
  width: TOOLBOX_MINIFIED_MENU_WIDTH,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: TOOLBOX_MAXIMIZED_MENU_WIDTH
});

export const StyledDrawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    width: TOOLBOX_MINIFIED_MENU_WIDTH,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
      ...openedMixin(theme),
      '& .MuiDrawer-paper': openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      '& .MuiDrawer-paper': closedMixin(theme),
    })
  }),
);

export const StyledListItemButton = styled(MuiListItemButton)(({ theme, selected }) => ({
  paddingLeft: "6px",
  paddingRight: "6px",
  borderRadius: "4px",
  transition: "none",
  ...selected && {
    '&.Mui-selected, &.Mui-selected:hover': {
      backgroundColor: THEME_COLORS[theme.palette.mode.toUpperCase()].SELECTED_BG
    }
  },
  "&:hover": {
    backgroundColor: THEME_COLORS[theme.palette.mode.toUpperCase()].SELECTED_BG,

    // ".MuiListItemIcon-root": {
    //   backgroundColor: THEME_COLORS[theme.palette.mode.toUpperCase()].SELECTED_BG,
    // }
  },
}));

export const StyledListItemIcon = styled(MuiListItemIcon)(({ theme }) => ({
  minWidth: "30px",
  marginRight: "20px",
  justifyContent: "center",
  "& svg": {
    fontSize: "18px !important",
    color: THEME_COLORS[theme.palette.mode.toUpperCase()].PRIMARY_FONT
  }
}));

export const StyledListItemText = styled(MuiListItemText)(({ theme }) => ({
  fontSize: 12,
  fontWeight: "normal",
  color: THEME_COLORS[theme.palette.mode.toUpperCase()].PRIMARY_FONT
}));

export const StyledDivider = styled(MuiDivider)(({ theme }) => ({
  marginTop: theme.spacing(1.5),
  marginBottom: theme.spacing(1.5),
}));
